import { tns } from "tiny-slider/src/tiny-slider";

export default class Slider {

    static setLogoSlider() {
        const slider = document.getElementById('logo-slider');
        const sliderControls = document.getElementById('logo-slider-controls');

        if (slider) {
            let tinySlider = tns({
                container: slider,
                mode: 'carousel',
                autoplayButtonOutput: false,
                controls: true,
                nav: false,
                autoplay: true,
                loop: true,
                controlsContainer: sliderControls || false,
                gutter: 20,
                autoWidth: true,
                responsive: {
                    768: {
                        gutter: 30
                    },
                    1280: {
                        gutter: 50
                    }
                }
            });
        }
    }

    static setProductDetail() {
        const slider = document.getElementById('jsProductSlider');
        const prev = document.getElementById('jsProductSliderPrev');
        const next = document.getElementById('jsProductSliderNext');

        if (slider && prev && next) {
            let productSlider = tns({
                container: slider,
                mode: 'carousel',
                items: 1,
                slideBy: 'page',
                autoplayButtonOutput: false,
                prevButton: prev,
                nextButton: next,
                nav: false,
            });
        }
    }
}
